import { render, staticRenderFns } from "./OrderInput.vue?vue&type=template&id=6f495706&scoped=true&"
import script from "./OrderInput.vue?vue&type=script&lang=js&"
export * from "./OrderInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f495706",
  null
  
)

export default component.exports